export enum PatientClasses {
  UNKNOWN = "Unknown",
  EMERGENCY = "Emergency",
  INPATIENT = "Inpatient",
  OUTPATIENT = "Outpatient",
  OBSERVATION = "Observation",
  OTHER = "Other",
}
